import Vue from 'vue'
import ApartmentConfig from '../vue/components/ApartmentConfig.vue'


export default {
  init() {
    // JavaScript to be fired on the home page
    Vue.component('apartment-config', ApartmentConfig)

    if ($('#apartmentConfig').length > 0) {
      new Vue({
        'el': '#apartmentConfig',
      });
    }
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/pageTemplateConfigurator.js